import React from 'react';
import IntroSection from '../components/IntroSection';
import PropSolutions from '../components/PropSolutions';
import BlueSectionDivider from '../components/BlueSectionDivider';
import PropBenefits from '../components/PropBenefits';
import CountriesSection from '../components/CountriesSection';
import TechStackSection from '../components/TechStackSection';
import PropFaq from '../components/PropFaq';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';


const Proptech=()=>{
    return (
        <div>
            <IntroSection title="Proptech Solutions" paragraph="Streamline operations, automate tasks and reduce operational costs with PropTech solutions" backgroundImage="/images/proptech-bg.webp"/>
            
            <PropSolutions/>
            <BlueSectionDivider/>
            <PropBenefits imageSrc="https://cdn.prod.website-files.com/63d3b504212f2224c6e39423/6408c29ee7c9a763a85a0567_Technical%20consultancy.webp"/>
            <BlueSectionDivider/>
            <CountriesSection/>
            <BlueSectionDivider/>
            <TechStackSection/>\
            <BlueSectionDivider/>
            <PropFaq/>
           <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>

        </div>
    )
}
export default Proptech;